import React from 'react';

export default function FwPhoneIcon({ color = 'currentColor', fontSize = '16px' }) {
  return (
    <>
      <i className='fas fa-phone' style={{ color, fontSize: fontSize }}></i>
    </>
  );
}
